import { CarouselInfoCardData } from '../ui/gzCarouselInfoCard/types';

export interface GuidedTourPayloadData {
  section: string;
  step: number;
  cards: Array<CarouselInfoCardData>;
  pointerTargets: Array<HTMLElement>;
  highlightTargets: Array<HTMLElement | Array<HTMLElement>>;
  hiddenForCurrentSession?: boolean;
  closeBtnTooltipText: string;
}

export enum CommonGuidedToursSteps {
  STEP_NOT_STARTED = 0,
  STEP_DISMISSED = -99,
  STEP_FINISHED = 999,
}

export enum GuidedTourSections {
  NETWORK = 'network',
}
